import axios from "axios";
import { FlowBaseCheckboxUpdateRequest } from "../models/requests/FlowBaseCheckboxUpdateRequest";
import { AutonomousFormBaseCheckbox } from "../models/responses/AutonomousFormBaseCheckbox";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlows";
function getCheckboxUrl(name: string, flowId: number) {
  return `/${flowId}/Checkbox/${name}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getCheckbox(name: string, flowId: number) {
  const url = getCheckboxUrl(name, flowId);
  return instance.get<AutonomousFormBaseCheckbox>(url);
}

async function setCheckbox(
  name: string,
  flowId: number,
  Checkbox: FlowBaseCheckboxUpdateRequest
) {
  return instance.post<AutonomousFormBaseCheckbox>(
    getCheckboxUrl(name, flowId),
    Checkbox
  );
}

async function clearCheckbox(name: string, flowId: number) {
  return instance.delete(getCheckboxUrl(name, flowId));
}

export const AutonomousFormBaseCheckboxService = {
  getCheckbox,
  setCheckbox,
  clearCheckbox
};
